
export const MESSAGES = {
  EMAIL_VALID: "Please enter a valid email.",
  PASS_REQUIRED: "Password is required.",
  PASSWORD_MUST_CHAR: "Password must be at least 8 characters.",
  LOGIN_SUCCESSFUL: "Login successfully!",
  INVALID_CREDENTIALS: "Invalid credentials",
  EMAIL_REQUIRED: "Email is required",
  FORGOT_PASSWORD: "Forgot password?",
  BRAND_NAME: "UNITED GROOVES",
  WELCOME_BACK: "Welcome Aboard!",
  ONBOARD_TITLE: "Complete Your Profile",
  ONBOARD_SUBTITLE: "Please finalize your details to access the United Grooves Admin Panel",
  LOGIN_SUBTITLE: "Enter your login information",
  EMAIL_LABEL: "Email",
  PASSWORD_LABEL: "Password",
  EMAIL_PLACEHOLDER: "Enter Your Email Address",
  PASSWORD_PLACEHOLDER: "Password",
  SIGN_IN: "Sign in",
  WORK_IN_PROGRESS: "Work in Progress",
  FORGOT_PASSWORD_SUBTITLE: "Enter your registered email address below. We’ll send you a secure link to reset your administrative credentials.",
  RESET_PASSWORD_SUBTITLE : "Enter your new password and confirm it to update your account security",
  RESET_PASSWORD: "Reset Password",
  FORGOT_PASSWORD_TITLE: "Forgot Password?",
  RESET_PASSWORD_BUTTON:"Get New Password",
  EMAIL_NOT_REGISTERED: "Email not found !",
  ALREADY_HAVE_ACCOUNT: "Already Have an Account?",
  DONT_HAVE_ACCOUNT: "Don't Have an Account?",
  PASSWORD_MIN: "Password must be at least 8 characters",
  PASSWORD_UPPER: "Password must contain at least one uppercase letter",
  PASSWORD_LOWER: "Password must contain at least one lowercase letter",
  PASSWORD_NUMBER: "Password must contain at least one number",
  PASSWORD_SPECIAL: "Password must contain at least one special character",
  PASSWORD_NOT_MATCH: "Passwords do not match",
  NEW_PASSWORD: "New Password",
  CONFIRM_PASSWORD: "Confirm New Password",
  CONFIRM_PASSWORD_PLACEHOLDER: "Confirm New Password",
  ONBOARD_SUCCESS: "Onboarding completed successfully",
  SIGNUP_TITLE: "Sign up",
  SIGNUP_SUBTITLE: "Join United Grooves Today",
  CONFIRM_PASSWORD_LABEL: "Confirm Password",
  SIGN_UP: "Sign up",
  SIGNUP_SUCCESSFUL: "Signup successful",
}
export const REGEX = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  UPPERCASE: /[A-Z]/,
  LOWERCASE: /[a-z]/,
  NUMBER: /\d/,
  SPECIAL_CHAR: /[!@#$%^&*(),.?":{}|<>]/,
};

export const PAGE_TITLES = {
  LOGIN: "Login",
  FORGOT_PASSWORD: "Forgot Password",
  RESET_PASSWORD: "Reset Password",
};

export const MSG = {
  FULLNAME_REQUIRED: "Full name is required",
  COMPANY_REQUIRED: "Company name is required",
  COUNTRY_REQUIRED: "Country is required",
  PHONE_REQUIRED: "Phone number is required",
  PHONE_INVALID: "Invalid phone number",
  POSTCODE_REQUIRED: "Postcode is required",
  POSTCODE_INVALID: "Invalid postcode",
  ADDRESS_REQUIRED: "Address is required",
  ADDRESS_MIN: "Address must be at least 5 characters",
  PHONE_REGEX : /^(?=(?:.*\d){6,})[0-9+\s-]{6,15}$/,
  POSTCODEREG: /^[a-zA-Z0-9 ]{4,10}$/,

  STATUS_UPDATED_SUCCESS: "Status updated successfully",
  STATUS_UPDATE_FAILED: "Failed to update status",
  ADMIN_UPDATED_SUCCESS: "Admin updated successfully",
  ADMIN_UPDATE_FAILED: "Failed to update admin",
  ACCOUNT_DEACTIVATED:
    "Account not approved. Please contact the admin.",
  ADMIN_REMOVED_SUCCESS: "Admin removed successfully",
  ADMIN_DELETE_CONFIRM: "Are you sure you want to delete admin?",
  CONFIRM_ACTION_PREFIX: "Are you sure you want to",
  FILE_SIZE_ERROR: "File size should not exceed 10MB",
  INVALID_FILE_FORMAT: "Invalid file format. Only JPG, JPEG, PNG, and PDF are allowed.",
};

export const INPUT_REGEX = {
  ONLY_ALPHABETS_SPACE: /[^a-zA-Z\s]/g,
};

export const FORM_LABELS = {
  EMAIL: "Email",
  FULL_NAME: "Full Name",
  PHONE: "Phone Number",
  ADDRESS: "Address",
  COUNTRY: "Country",
  POSTCODE: "Postcode",
  ADDRESS_FORM: "Street name,city,State"
};

export const FORM_PLACEHOLDERS = {
  EMAIL: "abc@example.com",
  FULL_NAME: "Enter Full name",
  NAME : "Enter full name", 
  PHONE_UK: "Enter phone number",
  ADDRESS: "Enter your full home address",
  COUNTRY: "Select country",
  POSTCODE: "Enter postcode",
  INSTRUCTOR_TYPE: "Instructor Type",
  INSTRUCTOR_ID: "Instructor ID",
  CLASS_STYLE: "Class Style",
  CLASS_TYPE: "Class Type",
  STUDENTS_COUNT: "Students Count",
  PROFILE_IMAGE: "Profile Image",
  UPLOAD_ID: "Upload ID (Government Issued)",
  ABOUT_INSTRUCTOR: "About Instructor",
};

export const BUTTON_TEXTS = {
  SUBMIT: "Submit",
  SAVING: "Saving...",
};

export const FOOTER_TEXT = {
  COPYRIGHT: "© 2026 Designed and Developed by",
  COMPANY_NAME: "Pheonixsolutions",
  RIGHTS: "All rights reserved.",
};
export const HEADER_TEXT = {
  APP_NAME: "United Grooves",
  WELCOME_MESSAGE: "Welcome Back,",
  HELLO: "Hello!",
  LOGOUT: "Logout",
  LOGOUT_CONFIRM_MESSAGE: "Are you sure you want to logout?",
};




export const CLASS_TYPE_OPTIONS = [
  { label: "Style Based", value: "STYLE_BASED" },
  { label: "Choreography", value: "CHOREOGRAPHY" },
];

export const DAY_OPTIONS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];


export const CLASS_MESSAGES = {
  DETAILS_TITLE: "Class Details",
  END_TIME_ERROR: "End time must be after start time",
  INVALID_TIME: "Invalid time",
  CREATE_FAILED: "Failed to create class",
  UPDATE_FAILED: "Failed to update class",
  IMAGE_SIZE_ERROR: "Image size should not exceed 10MB",
  INVALID_IMAGE_FORMAT: "Invalid file format. Only JPG, JPEG, and PNG are allowed.",
  DELETE_SUCCESS: "Class deleted successfully",
  DELETE_FAILED: "Failed to delete class",
};

export const CLASS_LABELS = {
  CLASS_NAME: "Class Name",
  INSTRUCTOR: "Instructor Name",
  CLASS_TYPE: "Select Class Type",
  TIME: "Time",
  DAY: "Date & Day",
  COVER_IMAGE: "Class Cover Image",
  DESCRIPTION: "Class Description",
};

export const CLASS_BUTTONS = {
  ADD: "Save",
  UPDATE: "Update",
  EDIT: "Edit",
  CANCEL: "Cancel",
  DELETE : "Delete"
};

export const CLASS_PLACEHOLDERS = {
  CLASS_NAME: "Class Name",
  INSTRUCTOR: "Select Instructor",
  CLASS_TYPE: "Select Class Type",
  DAY: "Select Date & Day",
  DESCRIPTION: "Briefly describe what students will learn in this class...",
};

export const CLASS_IMAGE_TEXT = {
  UPLOAD: "Upload",
  FORMAT_INFO: "JPG, PNG (MAX: 10MB)",
};

export const CLASS_REQUIRED_FIELDS = [
  "className",
  "instructorName",
  "instructorId",
  "classType",
  "day",
  "startTime",
  "endTime",
  "coverImage",
  "description",
] as const;

export const CLASS_PAGE_TEXT = {
  PAGE_TITLE: "Classes - United Grooves",

  HEADER: {
    DEFAULT: "Classes",
    VIEW: "View Classes",
    EDIT: "Edit Classes",
  },

  TABS: {
    ALL: "All Classes",
    ADD: "Add Classes",
  },

  BACK: "Back",
};

export const NOTIFICATION_PAGE_TEXT = {
  PAGE_TITLE: "Notifications - United Grooves",
};

export const ADMIN_PAGE_TEXT = {
  PAGE_TITLE: "Admin - United Grooves",
};

export const ATTENDANCE_PAGE_TEXT = {
  PAGE_TITLE: "Calendar - United Grooves",
};

export const CLASS_TYPE_UI: Record<
  string,
  { label: string; bg: string; color: string }
> = {
  STYLE_BASED: { label: "Style-Based", bg: "#E6FBEA", color: "#1E7F3D" },
  CHOREOGRAPHY: { label: "Choreography", bg: "#FFE8D9", color: "#C05621" },
  KRUMP: { label: "Krump", bg: "#F3E8FF", color: "#7E22CE" },
};

export const INSTRUCTOR_OPTIONS = ["Karan", "Anita", "Rahul"];

export const CLASS_LIST_TEXT = {
  NO_CLASSES: "No classes found",
  INSTRUCTOR_LABEL: "Instructors",
  STYLE_LABEL: "Style",
  PAGINATION_OF: "of",
};

export const CLASS_TABLE_TEXT = {
  SNO: "S.No",
  CLASS_NAME: "Class Name",
  INSTRUCTOR: "Instructors",
  TYPE: "Type",
  DAY: "Date & Day",
  DURATION: "Duration",
  TIME: "Time",
  STYLE: "Style",
  ACTION: "Actions",
  COMPLETED_DATE: "Completed Date",
  ATTENDANCE: "Attendance",
  SESSION_STATUS: "Session Status",
  FUTURE_DATE_DAY: "Future Date & Day",
  ENROLLMENT: "Enrollment",
  FETCH_ERROR: "Failed to fetch classes",
  GENERIC_ERROR: "Something went wrong",
  EMPTY: "-",
};

export const ATTENDANCE_MESSAGES = {
  REVIEW_TITLE: "Review Attendance",
  SUCCESS_TITLE: "Attendance Submitted!",

  REVIEW_DESCRIPTION: (present: number, total: number) =>
    `You are about to submit attendance for ${present} out of ${total} students. This action will update student progress and billing.`,

  SUCCESS_DESCRIPTION:
    "Great job! The attendance report for your session has been synchronized with student records and billing.",

  PRESENT: "PRESENT",
  ABSENT: "ABSENT",
  WALK_IN: "WALK-IN",

  GO_BACK: "Go Back",
  RETURN_TO_CLASSES: "Return to My Classes",
  SUBMIT: "Submit",
  SUBMIT_REPORT: "Submit Report",
};

export const ADD_ATTENDANCE_MESSAGES = {
  ADD_TITLE: "Add Attendance",
  ADD_SUBTITLE:
    "Enroll a student who isn’t on the schedule for this session.",

  SEARCH_STUDENT: "Search Student",
  SEARCH_PLACEHOLDER: "Enter Student Name",

  CATEGORY_LABEL: "Attendance Category",
  CATEGORY_PLACEHOLDER: "Select Category",

  CANCEL: "Cancel",
  ENROLL_PRESENT: "Enroll & Mark Present",

  CATEGORIES: [
    "Drop-In (Walk-in)",
    "Trial Session",
    "Manual Override",
  ],
};

export const PASS_TYPE_OPTIONS = [
  { label: "Drop-in", value: "Drop-in" },
  { label: "Weekly", value: "Weekly" },
  { label: "Monthly", value: "Monthly" },
];

export const ASSIGN_TYPE_OPTIONS = [
  { label: "10-Class Pass", value: "10_CLASS_PASS" },
  { label: "Monthly Unlimited", value: "MONTHLY_UNLIMITED" },
  { label: "Quarterly Unlimited", value: "QUARTERLY_UNLIMITED" },
  { label: "Single Class", value: "SINGLE_CLASS" },
];

export const STUDENT_REQUIRED_FIELDS = [
  "fullName",
  "email",
  "phoneNumber",
  "dateOfBirth",
  "address",
  "assignType",
  "assignToClass",
] as const;
